import debounce from 'lodash.debounce';
import throttle from 'lodash.throttle';

export default class MenuBar {
  constructor() {
    this.body = document.querySelector('body');
    this.mobileMenu = document.getElementById('nav-drawer__mobile');
    this.mobileMenuItems = this.mobileMenu.querySelectorAll('li > a');
    this.mobileMenuArrows = this.mobileMenu.querySelectorAll('li > .nav-item-arrow');
    this.mobileMenuBackBtn = this.mobileMenu.querySelectorAll('.back-btn');
    this.mobileSearchInput = this.mobileMenu.querySelector('.search__mobile input');
    this.mobileClearSearch = this.mobileMenu.querySelector('.search__mobile button.close');
    this.mobileSuggestedSearch = this.mobileMenu.querySelectorAll('.suggested li');
    this.desktopDrawers = document.querySelectorAll('.nav-container__desktop');
    this.desktopMenuItems = document.querySelectorAll('.main-nav__desktop > li');
    this.desktopNestedMenuItems = document.querySelectorAll('.nav-container__desktop .left a');
    this.desktopCloseButtons = document.querySelectorAll('.close-drawer-btn');
    this.desktopToggleSearchButton = document.querySelector('.bm-nav .search');

    this.desktopSearchContainer = document.querySelector('.search-container--desktop');
    this.desktopSearchInput = this.desktopSearchContainer.querySelector('.search-field input');
    this.desktopSearchLabel = this.desktopSearchContainer.querySelector('.search-field label');
    this.desktopClearSearch = this.desktopSearchContainer.querySelector('.search-field .clear');
    this.desktopSuggestedSearch = this.desktopSearchContainer.querySelectorAll('li');

    this.tabletSearchContainer = document.querySelector('.search-container--tablet');
    this.tabletSearchInput = this.desktopSearchContainer.querySelector('.search-field input');
    this.tabletSearchLabel = this.desktopSearchContainer.querySelector('.search-field label');
    this.tabletClearSearch = this.desktopSearchContainer.querySelector('.search-field .clear');
    this.tabletSuggestedSearch = this.desktopSearchContainer.querySelectorAll('li');


    this.hamburgerBtn = document.querySelector('#shopify-section-menu-bar .hamburger');
    this.cartBtn = document.querySelector('#shopify-section-menu-bar .cart');
    this.countrySelector = this.mobileMenu.querySelector('.nav-selector');
    this.lastScroll = 0;

    // Attach event listeners
    this.hamburgerBtn.addEventListener('click', this.toggleMobileDrawer.bind(this));
    this.cartBtn.addEventListener('click', this.openCart.bind(this));
    if (this.countrySelector) {
      this.countrySelector.addEventListener('change', this.changeSelector.bind(this));
    }
    window.addEventListener('mouseover', this.hideDesktopNav.bind(this));
    window.addEventListener('scroll', throttle(this.onScroll.bind(this), 400).bind(this));

    this.mobileMenuArrows.forEach((item) => {
      item.addEventListener('click', this.slideNav.bind(this));
    });

    this.mobileMenuBackBtn.forEach((button) => {
      button.addEventListener('click', this.slideBackNav.bind(this));
    });

    this.mobileClearSearch.addEventListener('click', () => {
      this.mobileSearchInput.value = '';
      this.mobileSearchInput.dispatchEvent(new Event('input', { bubbles: false }));
    });

    this.mobileSearchInput.addEventListener(
      'input',
      debounce((e) => {
        const value = e.target.value;
        const mainMenu = this.mobileMenu.querySelector('.main-menu');
        const searchContainer = this.mobileMenu.querySelector('.search-container--mobile');
        const searchIcon = this.mobileMenu.querySelector('.search__mobile button.search');
        const closeIcon = this.mobileMenu.querySelector('.search__mobile button.close');

        this.displaySearch(value, searchContainer, true);

        if (value) {
          mainMenu.classList.add('fade-hidden');
          searchContainer.classList.remove('fade-hidden');
          searchIcon.classList.add('display-hidden');
          closeIcon.classList.remove('display-hidden');
        } else {
          mainMenu.classList.remove('fade-hidden');
          searchContainer.classList.add('fade-hidden');
          searchIcon.classList.remove('display-hidden');
          closeIcon.classList.add('display-hidden');
        }
      }, 200)
    );

    this.mobileSuggestedSearch.forEach((suggestion) => {
      suggestion.addEventListener('click', (e) => {
        this.mobileSearchInput.value = e.target.innerText;
        this.mobileSearchInput.dispatchEvent(new Event('input', { bubbles: false }));
      });
    });

    this.desktopDrawers.forEach((drawer) => {
      drawer.addEventListener('mouseover', (e) => e.stopPropagation());
    });

    this.desktopMenuItems.forEach((item) => {
      item.addEventListener('mouseover', this.showDesktopNav.bind(this));
    });

    this.desktopNestedMenuItems.forEach((item) => {
      item.addEventListener('mouseover', this.showNestedDesktopNav.bind(this));
    });

    this.desktopCloseButtons.forEach((button) => {
      button.addEventListener('click', this.hideDesktopNav.bind(this));
    });

    this.desktopToggleSearchButton.addEventListener('mouseover', (e) => {
      e.stopPropagation();
      this.hideDesktopNav();
      this.desktopSearchContainer.classList.add('show');
      this.desktopToggleSearchButton.classList.add('search--open');

      this.desktopSearchInput.focus();
    });

    this.desktopSearchContainer.addEventListener('mouseover', (e) => e.stopPropagation());

    this.desktopSearchInput.addEventListener(
      'input',
      debounce((e) => {
        const value = e.target.value;

        this.displaySearch(value, this.desktopSearchContainer, false);

        if (!value) {
          this.desktopSearchContainer.querySelector('.results-count').innerText = '';
          // this.desktopSearchContainer.querySelector('.most-searched').classList.remove('hidden');
          this.desktopSearchContainer.querySelector('.suggested').classList.add('hidden');
          this.desktopClearSearch.classList.add('hidden');
        } else {
          this.desktopClearSearch.classList.remove('hidden');
        }
      }, 200)
    );

    this.desktopSearchInput.addEventListener(
      'input',
      debounce((e) => {
        const value = e.target.value;

        if (value) {
          this.desktopSearchLabel.classList.add('hidden');
        } else {
          this.desktopSearchLabel.classList.remove('hidden');
        }
      }, 10)
    );

    this.desktopSearchInput.addEventListener(
      'input',
      debounce((e) => {
        const value = e.target.value;
      }, 1000)
    );

    this.desktopClearSearch.addEventListener('click', () => {
      this.desktopSearchInput.value = '';
      this.desktopSearchInput.dispatchEvent(new Event('input', { bubbles: false }));
      this.desktopClearSearch.classList.add('hidden');
    });

    this.desktopSuggestedSearch.forEach((suggestion) => {
      suggestion.addEventListener('click', (e) => {
        this.desktopSearchInput.value = e.target.innerText;
        this.desktopSearchInput.dispatchEvent(new Event('input', { bubbles: false }));
      });
    });

    this.banner = document.querySelector('.banner');

    if ( this.banner ) {
      this.body.classList.add('banner-open');
    }
  }

  onScroll(e) {
    const curScroll = window.pageYOffset;

    if (!this.body.classList.contains('menu-open')) {
      if (curScroll > this.lastScroll) {
        // Scrolling down, hide nav
        this.body.classList.add('scrolling-down');
      } else {
        // Scrolling up, show nav
        this.body.classList.remove('scrolling-down');
      }
    }
    this.lastScroll = curScroll <= 0 ? 0 : curScroll;
  }

  toggleMobileDrawer(e) {
    this.body.classList.add('menu-open');
    this.mobileMenu.classList.toggle('show');

    // if closing mobile nav
    if (!this.mobileMenu.classList.contains('show')) {
      this.body.classList.remove('menu-open');
      this.mobileMenu.ontransitionend = () => {
        // 'reset' main menu after nav fades
        const mobileMenuList = this.mobileMenu.querySelector('.main-menu');
        mobileMenuList.style.transform = `translateX(0%)`;

        const nested = mobileMenuList.querySelectorAll('.nested');
        nested.forEach(function (el) {
          el.classList.add('hidden');
        });

        this.mobileMenu.ontransitionend = null;
      };
    }
  }

  slideNav(e) {
    e.stopPropagation();

    let target = e.target;
    while (target.tagName !== 'LI') target = target.parentElement;

    console.log(target)

    // Open link if menu does not have children
    let isRedirect = true;
    const children = target.children;
    const childrenSize = children.length;
    for (let i = 0; i < childrenSize; i++) {
      if (children[i].classList.contains('nested')) {
        isRedirect = false;
        children[i].classList.remove('hidden');
        break;
      }
    }

    if (isRedirect) return;
    else e.preventDefault();

    // Slide drawer
    const mobileMenuList = this.mobileMenu.querySelector('.main-menu');
    if (!mobileMenuList.style.transform) {
      mobileMenuList.style.transform = 'translateX(-100%)';
    } else {
      const numberPattern = /\d+/g;
      const slide = parseInt(mobileMenuList.style.transform.match(numberPattern)[0]) + 100;

      mobileMenuList.style.transform = `translateX(-${slide}%)`;
    }
  }

  slideBackNav(e) {
    e.stopPropagation();

    // Slide drawer back
    const mobileMenuList = this.mobileMenu.querySelector('.main-menu');
    const numberPattern = /\d+/g;
    const slide = parseInt(mobileMenuList.style.transform.match(numberPattern)[0]) - 100;

    mobileMenuList.style.transform = `translateX(-${slide}%)`;

    let target = e.target;
    while (target.tagName !== 'UL') target = target.parentElement;
    setTimeout(() => {
      target.classList.add('hidden');
    }, 300);
  }

  hideDesktopNav() {
    this.desktopDrawers.forEach((el) => el.classList.remove('show'));
    this.desktopMenuItems.forEach((item) => item.classList.remove('active'));

    this.desktopSearchContainer.classList.remove('show');
    this.desktopToggleSearchButton.classList.remove('search--open');
    if( !this.mobileMenu.classList.contains('show') ) {
      this.body.classList.remove('menu-open');
    }
  }

  hideNestedDesktopNav() {
    this.desktopNestedMenuItems.forEach((item) => item.classList.remove('active'));
    const nestedNav = document.querySelectorAll(`.nav-container__desktop .nested`);
    nestedNav.forEach((nav) => nav.parentNode.classList.remove('show'));
  }

  showDesktopNav(e) {
    e.stopPropagation();

    let target          = e.target;
    let key             = target.dataset.key;
    let selectedDrawer  = document.querySelector(`.nav-container__desktop[data-nav=${key}]`);

    const hasDropdown = target.classList.contains('has-dropdown');

    if (e.target.tagName.toLowerCase() === 'a') {
      target          = e.parentElement;

      if (target != undefined) {
        key             = target.dataset.key;
        selectedDrawer  = document.querySelector(`.nav-container__desktop[data-nav=${key}]`);
      };
    }

    if (hasDropdown) {
      this.hideDesktopNav();
      this.hideNestedDesktopNav();
      this.body.classList.add('menu-open');
      selectedDrawer.classList.add('show');
      target.classList.add('active');

      if (key === 'our-products') {
        document
          .querySelector('.nav-container__desktop .nested[data-key=skincare]').parentNode.classList.add('show');
        document
          .querySelector('.nav-container__desktop a[data-key=skincare]').classList.add('active');
      }
    };
  }

  showNestedDesktopNav(e) {
    e.stopPropagation();

    const target = e.target;
    const key = target.dataset.key;
    const nestedNav = document.querySelector(`.nav-container__desktop .nested[data-key=${key}]`);

    this.hideNestedDesktopNav();
    if (nestedNav) nestedNav.parentNode.classList.add('show');
    target.classList.add('active');
  }

  openCart(e) {
    e.stopPropagation();

    this.body.classList.add('cart-open');

    const cart = document.getElementById('shopify-section-cart');
    cart.classList.add('show');
  }

  changeSelector(e) {
    const target = e.target;
    window.location.href = target.value;
  }

  displaySearch(value, searchContainer, isMobile) {
    const searchResult = searchContainer.querySelector('.result');
    // const mostSearchedEl = searchContainer.querySelector('.most-searched');

    if (value) {
      this.fetchSearchQuery(value).then((products) => {
        this.clearSearchResult(searchResult);
        // Remove samples
        products = products.filter((p) => (p.price !== '0.00' && !Shopify.searchExcludeProductsIDs.includes(p.id)));

        const productCount = products.length;
        const hidden = isMobile ? 'display-hidden' : 'hidden';
        const resultCountEl = searchContainer.querySelector('.results-count');
        resultCountEl.innerText = `${productCount} result${productCount != 1 ? 's' : ''}`;

        // if (!isMobile) mostSearchedEl.classList.add('hidden');

        if (productCount > 0) {
          searchContainer.querySelector('.suggested').classList.add(hidden);

          products.forEach((product) => {
            const el = document.createElement('a');
            el.setAttribute('href', product.url);
            let productVariantTitle = '';

            if (product.variants.length) {
              productVariantTitle = product.variants[0].title != 'Default Title' ? ' ' + product.variants[0].title : '';
            }
            el.innerHTML = `
                <img src="${product.featured_image.url}" alt="Korres${productVariantTitle} ${product.title}">
                <h3>${product.title}</h3>
                <p>$${product.price}</p>
              `;

            searchResult.appendChild(el);
          });
        } else {
          searchContainer.querySelector('.suggested').classList.remove(hidden);
        }
      });
    } else {
      this.clearSearchResult(searchResult);
    }
  }

  fetchSearchQuery(query) {
    return fetch(
      `/search/suggest.json?q=${query}` +
        `&resources[type]=product` +
        `&resources[limit]=10` +
        `&resources[options][unavailable_products]=last` +
        `&resources[options][fields]=tag,title,variants.title,product_type`
    )
      .then((res) => res.json())
      .then((suggestions) => {
        return suggestions.resources.results.products;
      })
  }

  clearSearchResult(el) {
    while (el.firstChild) {
      el.removeChild(el.firstChild);
    }
  }
}
